import { render, staticRenderFns } from "./ClaimScoutingReportForm.vue?vue&type=template&id=471360a5&"
import script from "./ClaimScoutingReportForm.vue?vue&type=script&lang=ts&"
export * from "./ClaimScoutingReportForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports